import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {LoginService} from './login.service';
import {Router} from '@angular/router';
import {getBaseUrl, getDatabase} from '../../environments/environment-functions';
import {AvailableClient} from '../models/AvailableClient';
import {lastValueFrom} from "rxjs";
import {SystemInfo} from "../models/SystemInfo";
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxSpinnerModule } from 'ngx-spinner';
import { RouterModule } from '@angular/router';
import { NgxMaskDirective } from 'ngx-mask';
import {loginValidator} from "./ValidadorLogin";

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatCardModule, MatInputModule, MatButtonModule, MatSelectModule, MatIconModule, MatFormFieldModule, NgxSpinnerModule, RouterModule, NgxMaskDirective],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  constructor(
      private loginService: LoginService,
      private router: Router,
  ) {

  }

  form: FormGroup = new FormGroup({
    login: new FormControl('', [Validators.required, loginValidator()]),
    password: new FormControl('', [Validators.required])
  });

  clientList: AvailableClient[] = [];
  systemInfo: SystemInfo = {} as SystemInfo;
  hidePassword: boolean = true;
  isLoading: boolean = false;
  cpfCnpjMask: string = '000.000.000-00||00.000.000/0000-00';
  async ngOnInit(): Promise<any> {
    try {
      await this.bindDatabase();
      this.loginService.showSpinner();
      this.clientList = await lastValueFrom(this.loginService.getClientsList());
      this.systemInfo = await lastValueFrom(this.loginService.getVersionInfo());
    } catch (e) {
      console.error(e);
      this.loginService.toasterError('Houve um erro ao montar tela');
    } finally {
      this.loginService.hideSpinner();
    }
  }

  async bindDatabase(): Promise<any> {
    const field = getDatabase();
    if(field){
      localStorage.setItem('x-database-group', field);
      this.setCookie("x-database-group", field, 2);
    }
  }

  async login(): Promise<any> {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }

    try {
      this.isLoading = true;
      this.loginService.showSpinner();
      const value = this.form.value;
      const data = await lastValueFrom(this.loginService.login(this.normalizarLogin(value?.login), value?.password));
      localStorage.clear();
      localStorage.setItem('x-session-token-ac', data);
      localStorage.setItem('x-database-group', value?.database);
      this.setCookie("x-session-token-ac", data, 2);
      this.setCookie("x-database-group", value?.database, 2);
      this.loginService.hideSpinner();
      await this.router.navigate(['/principal/dashboard']);
    } catch (error: any) {
      this.loginService.hideSpinner();
      console.error(error);
      this.loginService.toasterWarning(error.error, 'Erro');
    } finally {
      this.isLoading = false;
    }
  }

  logo(): string {
    return getBaseUrl() + 'client_area/logo?database=' + getDatabase();
  }

  private normalizarLogin(login: string): string {
    const valor = login.trim();

    const pareceEmail = valor.includes('@');

    if (pareceEmail) {
      return valor.toLowerCase();
    }

    return valor.replace(/\D/g, '');
  }

  setCookie(name: string, value: string, days: number) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
}
